import React from 'react'
import { Breadcrumb } from 'react-bootstrap'
import { BrowserView, isMobile, MobileView } from 'react-device-detect'
import { Link } from 'react-router-dom'
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { is } from 'date-fns/locale'
import styled from 'styled-components'
import { colors } from '../styleGuide'

export interface DcBreadcrumbsProps {
  data: any
  className?: string
  fontSize?: string
}

const StyledDcBreadcrumbs = styled(Breadcrumb)<{ fontSize?: string }>`
  ol {
    margin: 0;
  }
  .breadcrumb-item {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    a {
      text-decoration: none;
      color: ${colors.grayInputDark};
      font-weight: 500;
      font-size: 0.75rem;
      font-size: ${(props) => props.fontSize};
    }
    &.active {
      color: ${colors.grayMedium};
      font-weight: 500;
      font-size: 0.75rem;
      font-size: ${(props) => props.fontSize};
      &:before {
        opacity: 0.6 !important;
      }
    }
    &:before {
      content: ' ' !important;
      color: ${colors.grayMedium};
      font-size: 7px;
      width: 8px; /* Adjust width and height if needed */
      height: 8px;
      /* display: inline-block; */

      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgNTEyIj48IS0tISBGb250IEF3ZXNvbWUgUHJvIDYuMC4wIGJ5IEBmb250YXdlc29tZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tIExpY2Vuc2UgLSBodHRwczovL2ZvbnRhd2Vzb21lLmNvbS9saWNlbnNlIChDb21tZXJjaWFsIExpY2Vuc2UpIENvcHlyaWdodCAyMDIyIEZvbnRpY29ucywgSW5jLiAtLT48cGF0aCBkPSJNNjQgNDQ4Yy04LjE4OCAwLTE2LjM4LTMuMTI1LTIyLjYyLTkuMzc1Yy0xMi41LTEyLjUtMTIuNS0zMi43NSAwLTQ1LjI1TDE3OC44IDI1Nkw0MS4zOCAxMTguNmMtMTIuNS0xMi41LTEyLjUtMzIuNzUgMC00NS4yNXMzMi43NS0xMi41IDQ1LjI1IDBsMTYwIDE2MGMxMi41IDEyLjUgMTIuNSAzMi43NSAwIDQ1LjI1bC0xNjAgMTYwQzgwLjM4IDQ0NC45IDcyLjE5IDQ0OCA2NCA0NDh6Ii8+PC9zdmc+);
      display: inline-block;
      vertical-align: middle;
      background-repeat: no-repeat;
      background-position: center center;
      float: none !important;
      margin-right: 8px;
      opacity: 0.4;
    }
    &:first-child:before {
      content: none !important; /* Remove angle for the first breadcrumb */
    }
  }
`

export const DcBreadcrumbs = React.forwardRef<
  HTMLDivElement,
  DcBreadcrumbsProps
>(({ className, data, fontSize, ...rest }, ref) => {
  return (
    <React.Fragment>
      <BrowserView>
        <StyledDcBreadcrumbs fontSize={fontSize}>
          {data.length &&
            data.map((item, index) => (
              <Breadcrumb.Item
                linkAs={item.link ? Link : undefined}
                key={index}
                active={item.active}
                linkProps={{ to: item.link }}
              >
                {item.name}
              </Breadcrumb.Item>
            ))}
        </StyledDcBreadcrumbs>
      </BrowserView>
      <MobileView>
        <StyledDcBreadcrumbs>
          <Row isMobile={isMobile}>
            {data.length > 2 && (
              <React.Fragment>
                <Link to={data[data.length - 2].link}>
                  <FontAwesomeIcon icon={faArrowLeftLong} />
                </Link>
              </React.Fragment>
            )}
            <Breadcrumb.Item
              linkAs={data[data.length - 1].link ? Link : undefined}
              key={1}
              active={data[data.length - 1].active}
              linkProps={{ to: data[data.length - 1].link }}
            >
              {data[data.length - 1].name}
            </Breadcrumb.Item>
          </Row>
        </StyledDcBreadcrumbs>
      </MobileView>
    </React.Fragment>
  )
})

const Row = styled.div<{ isMobile: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: ${(props) => (props.isMobile ? '0 0 0 16px' : '0')};
`
export default DcBreadcrumbs
